export default "__VITE_ASSET__737f6a44__"